import React, { Component } from 'react'
import Mensagem from '../../common/Mensagem'
import { Link } from 'react-router-dom';
import Icon from '../../assets/task-done-flat.png';
import Masculino from '../../assets/masculino.png';
import api from '../../services/api';

class NavBar extends Component {
    
    constructor(props){
        super(props);
        this.state = { usuario: '', empresa:'', permissao:'' } 
        this.handleLogout = this.handleLogout.bind(this);      
    }

    async componentDidMount() {
        const usuario   = sessionStorage.getItem('usuario');
        const empresa   = sessionStorage.getItem('fantasia');
        const grupo     = sessionStorage.getItem('grupo');

         
        if( !usuario ) {
            console.log('aqui')
            this.props.history.push('/');
        }


        const token    = sessionStorage.getItem('token');
        
        const permissoes = await api.get(`/api/permissao/${grupo}`, {
            headers: {
                'x-access-token':token,
            }
        });
       

        const homePage                  = permissoes.data.filter(function(value){ return value.idmenu  == 1 });
        const empresaPage               = permissoes.data.filter(function(value){ return value.idmenu  == 2 });
        const pessoaPage                = permissoes.data.filter(function(value){ return value.idmenu  == 3 });
        const vendaPage                 = permissoes.data.filter(function(value){ return value.idmenu  == 4 });
        const producaoPage              = permissoes.data.filter(function(value){ return value.idmenu  == 5 });
        const separacaoPage             = permissoes.data.filter(function(value){ return value.idmenu  == 6 });
        const lavarPage                 = permissoes.data.filter(function(value){ return value.idmenu  == 7 });
        const passarPage                = permissoes.data.filter(function(value){ return value.idmenu  == 8 });
        const relatorioPage             = permissoes.data.filter(function(value){ return value.idmenu  == 9 });
        const relatorioVendaPage        = permissoes.data.filter(function(value){ return value.idmenu  == 10});
        const relatorioPagamentoPage    = permissoes.data.filter(function(value){ return value.idmenu  == 11});
        const relatorioFaturamentoPage  = permissoes.data.filter(function(value){ return value.idmenu  == 12});
        const relatorioProducaoPage     = permissoes.data.filter(function(value){ return value.idmenu  == 13});
        const auxiliarPage              = permissoes.data.filter(function(value){ return value.idmenu  == 14});
        const grupoServicoPage          = permissoes.data.filter(function(value){ return value.idmenu  == 15});
        const servicoPage               = permissoes.data.filter(function(value){ return value.idmenu  == 16});
        const precificacaoPage          = permissoes.data.filter(function(value){ return value.idmenu  == 17}); 
        const pagamentoPage             = permissoes.data.filter(function(value){ return value.idmenu  == 18}); 
        const comissaoPage              = permissoes.data.filter(function(value){ return value.idmenu  == 23}); 
        const relatorioComissao         = permissoes.data.filter(function(value){ return value.idmenu  == 22}); 
        const chatBotPage               = permissoes.data.filter(function(value){ return value.idmenu  == 25});
        const configuracaoPedidoPage    = permissoes.data.filter(function(value){ return value.idmenu  == 26});
        const segurancaPage             = permissoes.data.filter(function(value){ return value.idmenu  == 19}); 
        const usuarioPage               = permissoes.data.filter(function(value){ return value.idmenu  == 20}); 
        const grupoPage                 = permissoes.data.filter(function(value){ return value.idmenu  == 21}); 
        
        const menu = {
            homePage:                   homePage.length > 0 && 
                                        homePage[0].permissao && 
                                        homePage[0].permissao.indexOf('VER') >= 0 ? true : false,
            empresaPage:                empresaPage.length > 0 && 
                                        empresaPage[0].permissao && 
                                        empresaPage[0].permissao.indexOf('VER') >= 0 ? true : false,
            pessoaPage:                 pessoaPage.length > 0 && 
                                        pessoaPage[0].permissao && 
                                        pessoaPage[0].permissao.indexOf('VER') >= 0 ? true : false,
            vendaPage:                  vendaPage.length > 0 && 
                                        vendaPage[0].permissao && 
                                        vendaPage[0].permissao.indexOf('VER') >= 0 ? true : false,
            producaoPage:               producaoPage.length > 0 && 
                                        producaoPage[0].permissao && 
                                        producaoPage[0].permissao.indexOf('VER') >= 0 ? true : false,
            separacaoPage:              separacaoPage.length > 0 && 
                                        separacaoPage[0].permissao && 
                                        separacaoPage[0].permissao.indexOf('VER') >= 0 ? true : false,
            lavarPage:                  lavarPage.length > 0 && 
                                        lavarPage[0].permissao && 
                                        lavarPage[0].permissao.indexOf('VER') >= 0 ? true : false,
            passarPage:                 passarPage.length > 0 && 
                                        passarPage[0].permissao && 
                                        passarPage[0].permissao.indexOf('VER') >= 0 ? true : false,
            relatorioPage:              relatorioPage.length > 0 && 
                                        relatorioPage[0].permissao && 
                                        relatorioPage[0].permissao.indexOf('VER') >= 0 ? true : false,
            relatorioVendaPage:         relatorioVendaPage.length > 0 && 
                                        relatorioVendaPage[0].permissao && 
                                        relatorioVendaPage[0].permissao.indexOf('VER') >= 0 ? true : false,
            relatorioPagamentoPage:     relatorioPagamentoPage.length > 0 && 
                                        relatorioPagamentoPage[0].permissao && 
                                        relatorioPagamentoPage[0].permissao.indexOf('VER') >= 0  ? true : false,
            relatorioFaturamentoPage:   relatorioFaturamentoPage.length > 0 && 
                                        relatorioFaturamentoPage[0].permissao && 
                                        relatorioFaturamentoPage[0].permissao.indexOf('VER') >= 0 ? true : false,
            relatorioProducaoPage:      relatorioProducaoPage.length > 0 &&
                                        relatorioProducaoPage[0].permissao &&
                                        relatorioProducaoPage[0].permissao.indexOf('VER') >= 0 ? true : false,
            relatorioComissaoPage:      relatorioComissao.length > 0 &&
                                        relatorioComissao[0].permissao &&
                                        relatorioComissao[0].permissao.indexOf('VER') >= 0 ? true : false,
            auxiliarPage:               auxiliarPage.length > 0 && 
                                        auxiliarPage[0].permissao && 
                                        auxiliarPage[0].permissao.indexOf('VER') >= 0  ? true : false,
            grupoServicoPage:           grupoServicoPage.length > 0 && 
                                        grupoServicoPage[0].permissao && 
                                        grupoServicoPage[0].permissao.indexOf('VER') >= 0  ? true : false,          
            servicoPage:                servicoPage.length > 0 && 
                                        servicoPage[0].permissao && 
                                        servicoPage[0].permissao.indexOf('VER') >= 0  ? true : false,
            precificacaoPage:           precificacaoPage.length > 0 && 
                                        precificacaoPage[0].permissao && 
                                        precificacaoPage[0].permissao.indexOf('VER') >= 0  ? true : false,
            pagamentoPage:              pagamentoPage.length > 0 && 
                                        pagamentoPage[0].permissao && 
                                        pagamentoPage[0].permissao.indexOf('VER') >= 0  ? true : false,
            comissaoPage:               comissaoPage.length > 0 && 
                                        comissaoPage[0].permissao && 
                                        comissaoPage[0].permissao.indexOf('VER') >= 0  ? true : false,
            chatBotPage:                chatBotPage.length > 0 && 
                                        chatBotPage[0].permissao && 
                                        chatBotPage[0].permissao.indexOf('VER') >= 0  ? true : false,
            configuracaoPedidoPage:     configuracaoPedidoPage.length > 0 && 
                                        configuracaoPedidoPage[0].permissao && 
                                        configuracaoPedidoPage[0].permissao.indexOf('VER') >= 0  ? true : false,
            segurancaPage:              segurancaPage.length > 0 && 
                                        segurancaPage[0].permissao && 
                                        segurancaPage[0].permissao.indexOf('VER') >= 0  ? true : false,
            usuarioPage:                usuarioPage.length > 0 && 
                                        usuarioPage[0].permissao && 
                                        usuarioPage[0].permissao.indexOf('VER') >= 0  ? true : false,
            grupoPage:                  grupoPage.length > 0 && 
                                        grupoPage[0].permissao && 
                                        grupoPage[0].permissao.indexOf('VER') >= 0  ? true : false,  
        }
    
        this.setState({ usuario: usuario, empresa: empresa, permissao:menu });
        
    }

    handleLogout = async (event) => {
        sessionStorage.clear();
        window.location.href = "/"   
        
    }

    render() {
                
        return  <nav class="main-header navbar navbar-expand navbar-light navbar-white ">
                    <div class="container">
                        <button class="navbar-toggler order-1" type="button" data-toggle="collapse" data-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                            <span class="navbar-toggler-icon"></span>
                        </button>
                        <div class="collapse navbar-collapse order-3" id="navbarCollapse">
                            <ul class="navbar-nav">
                                <li class="nav-item dropdown">
                                    <a id="dropdownSubMenu1" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="nav-link dropdown-toggle">
                                        <img src={ Icon } alt="AdminLTE Logo" class="brand-image img-circle elevation-3"/>
                                        <span class="brand-text font-weight-light">START</span>
                                    </a>
                                    <ul aria-labelledby="dropdownSubMenu1" class="dropdown-menu border-0 shadow">
                                        <li><Link to="/index" class="dropdown-item"><i class="fas fa-home"></i> Home</Link></li> 
                                        <li>
                                            {
                                                this.state.permissao.empresaPage ?
                                                <Link to="/empresa" class="dropdown-item"><i class="fas fa-building"></i> Empresa</Link> :      
                                                ''                                      
                                            }
                                        </li> 
                                        <li>
                                            {
                                                this.state.permissao.pessoaPage ?
                                                <Link to="/pessoa" class="dropdown-item"><i class="fas fa-male"></i> Pessoas</Link> :
                                                ''
                                            }
                                        </li> 
                                        <li>
                                            {
                                                this.state.permissao.vendaPage ?
                                                <Link to="/venda" class="dropdown-item"><i class="fas fa-shopping-cart"></i> Vendas</Link> :
                                                ''
                                            }
                                            {

                                            //    <Link to="/pdv" class="dropdown-item"><i class="fas fa-cash-register"></i> PDV</Link> 
                                            }
                                            {
                                                this.state.permissao.vendaPage ?
                                                <Link to="/combo" class="dropdown-item"><i class="fas fa-sitemap"></i> Combos</Link> :
                                                ''
                                            }
                                        </li> 
                                        {
                                            this.state.permissao.producaoPage ?
                                            <li class="dropdown-submenu dropdown-hover">
                                                <a id="dropdownSubMenu2" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-item dropdown-toggle"><i class="fas fa-diagnoses"></i> Produção</a>
                                                <ul aria-labelledby="dropdownSubMenu2" class="dropdown-menu border-0 shadow">
                                                    <li>   
                                                        {
                                                            this.state.permissao.separacaoPage ?
                                                            <Link to="/separacao" class="dropdown-item"><i class="fas fa-dolly"></i> Separação</Link> : ''
                                                        }
                                                        {
                                                            this.state.permissao.lavarPage ?
                                                            <Link to="/lavar" class="dropdown-item"><i class="fas fa-shower"></i> Lavar</Link> : ''
                                                        }
                                                        {
                                                            this.state.permissao.passarPage ?
                                                            <Link to="/passar" class="dropdown-item"><i class="fas fa-tshirt"></i> Passar</Link> :''
                                                        }                                                     
                                                    </li>
                                                </ul>
                                            </li> :
                                            ''                                           
                                        }
                                        {
                                            this.state.permissao.relatorioPage ?
                                            <li class="dropdown-divider"></li> :
                                            ''
                                        }   
                                        {
                                            this.state.permissao.relatorioPage ?
                                            <li class="dropdown-submenu dropdown-hover">
                                                <a id="dropdownSubMenu2" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-item dropdown-toggle"><i class="far fa-file"></i> Relatórios</a>
                                                <ul aria-labelledby="dropdownSubMenu2" class="dropdown-menu border-0 shadow">
                                                    <li>        
                                                        {
                                                            this.state.permissao.relatorioVendaPage ?
                                                            <Link to="/relatoriovendas" class="dropdown-item"><i class="fas fa-calendar"></i> Acompanhamento de Vendas</Link> : ''
                                                        }   

                                                        {
                                                            this.state.permissao.relatorioPagamentoPage ?
                                                            <Link to="/relatoriofaturamento" class="dropdown-item"><i class="fas fa-calendar"></i> Faturamento Por Valor</Link> : ''
                                                        }

                                                        {
                                                            this.state.permissao.relatorioFaturamentoPage ?
                                                            <Link to="/relatorioservico" class="dropdown-item"><i class="fas fa-calendar"></i> Faturamento Por Serviço</Link> : ''
                                                        } 

                                                        {
                                                            this.state.permissao.relatorioProducaoPage ?
                                                            <Link to="/relatorioseparacao" class="dropdown-item"><i class="fas fa-calendar"></i> Separação Por Serviço</Link> : ''
                                                        } 
                                                        {
                                                            this.state.permissao.relatorioComissaoPage ?
                                                            <Link to="/relatoriocomissao" class="dropdown-item"><i class="fas fa-calendar"></i> Comissão</Link> : ''
                                                        } 
                                                        {
                                                            this.state.permissao.relatorioComissaoPage ?
                                                            <Link to="/relatoriopreco" class="dropdown-item"><i class="fas fa-calendar"></i> Tabela Preço</Link> : ''
                                                        }                                     
                                                    </li>
                                                </ul>
                                            </li> :
                                            ''                                           
                                        }
                                        {
                                            this.state.permissao.auxiliarPage ?
                                            <li class="dropdown-divider"></li> :''
                                        }
                                        {
                                            this.state.permissao.auxiliarPage ?
                                            <li class="dropdown-submenu dropdown-hover">
                                                <a id="dropdownSubMenu2" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-item dropdown-toggle"><i class="far fa-folder"></i> Aux Vendas</a>
                                                <ul aria-labelledby="dropdownSubMenu2" class="dropdown-menu border-0 shadow">
                                                    <li>
                                                        {
                                                            this.state.permissao.grupoServicoPage ? 
                                                            <Link to="/gruposervico" class="dropdown-item"><i class="fas fa-cubes"></i> Grupo Serviço</Link> : ''
                                                        }

                                                        {
                                                            this.state.permissao.servicoPage ? 
                                                            <Link to="/servico" class="dropdown-item"><i class="fas fa-wrench"></i> Serviços</Link> : ''
                                                        }

                                                        {
                                                            this.state.permissao.precificacaoPage ? 
                                                            <Link to="/promocao" class="dropdown-item"><i class="fas fa-tags"></i> Promoção</Link> : ''
                                                        }

                                                        {
                                                            this.state.permissao.pagamentoPage ? 
                                                            <Link to="/pagamento" class="dropdown-item"><i class="fas fa-credit-card"></i> Meio Pagamento</Link> : ''
                                                        }

                                                        {
                                                            this.state.permissao.comissaoPage ? 
                                                            <Link to="/comissao" class="dropdown-item"><i class="fas fa-percentage"></i> Comissão</Link> : ''
                                                        }
                                                        {

                                                            this.state.permissao.chatBotPage ?
                                                            <li class="dropdown-submenu dropdown-hover">
                                                                <a id="dropdownSubMenu2" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-item dropdown-toggle"><i class="fas fa-robot"></i> Chat Bot</a>
                                                                <ul aria-labelledby="dropdownSubMenu2" class="dropdown-menu border-0 shadow">
                                                                    <li>
                                                                        {
                                                                            this.state.permissao.configuracaoPedidoPage ? 
                                                                            <Link to="/chatBotPedido" class="dropdown-item"><i class="fas fa-comments-dollar"></i> Configuração de Pedido</Link> : ''
                                                                        }
                                                                    </li>
                                                                </ul>
                                                            </li> :''
                                                        }
                                                    </li>
                                                </ul>
                                            </li>
                                            : ''
                                        }
                                       {
                                           this.state.permissao.segurancaPage ?
                                           <li class="dropdown-divider"></li> : ''
                                       }
                                       {
                                           this.state.permissao.segurancaPage ?
                                           <li class="dropdown-submenu dropdown-hover">
                                                <a id="dropdownSubMenu2" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="dropdown-item dropdown-toggle"><i class="fas fa-user-shield"></i> Segurança</a>
                                                <ul aria-labelledby="dropdownSubMenu2" class="dropdown-menu border-0 shadow">
                                                    <li>
                                                        {
                                                            this.state.permissao.usuarioPage ? 
                                                            <Link to="/usuario" class="dropdown-item"><i class="fas fa-user"></i> Usuário</Link>
                                                            : ''
                                                        }
                                                        {
                                                            this.state.permissao.grupoPage ?
                                                            <Link to="/grupo"   class="dropdown-item"><i class="fas fa-user-lock"></i> Grupo e Permissão</Link>
                                                            : '' 
                                                        }
                                                    </li>
                                                </ul>
                                            </li> : ''
                                       }                                        
                                    </ul>            
                                </li>          
                            </ul>

                            <ul class="order-1 order-md-3 navbar-nav navbar-no-expand ml-auto">
                               
                                <li class="nav-item dropdown user-menu">
                                
                                    <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown">
                                        <img src={ Masculino } class="user-image img-circle elevation-2" alt="User Image"/>
                                        <span class="d-none d-md-inline">{ this.state.usuario }</span>
                                    </a>
                                    
                                </li>          
                                
                                <li class="nav-item">
                                    <a href="#" class="nav-link" onClick={ this.handleLogout }><i class="fas fa-sign-out-alt"></i> Sair</a>
                                </li>
                            </ul>
                        </div>      
                    </div>
                    <Mensagem />
                </nav>
    }
}

export default NavBar;